'use client'

import { useCurrentUserQuery } from '@/api'
import { redirect } from 'next/navigation'

export default function MyPageLayout({
  children,
}: Readonly<{
  children: React.ReactNode
}>) {
  const { data: { currentUser } = {} } = useCurrentUserQuery()

  if (currentUser === undefined) return null
  if (currentUser === null) {
    redirect('/')
  }

  return children
}
